/** Number formatting for the shared components. Kept here so the design system has no domain dependencies. */
const gbpFull = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 });
const gbpPence = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const intFmt = new Intl.NumberFormat("en-GB");

/** £12,345 (whole pounds). Pass pence=true for £12,345.67. */
export function gbp(n: number | null | undefined, pence = false): string {
  if (n === null || n === undefined || !isFinite(n)) return "—";
  return (pence ? gbpPence : gbpFull).format(n);
}

/** £1.2k, £34k, £1.4m — for dense displays. */
export function gbpShort(n: number | null | undefined): string {
  if (n === null || n === undefined || !isFinite(n)) return "—";
  const abs = Math.abs(n);
  const sign = n < 0 ? "−" : "";
  if (abs >= 1_000_000) return `${sign}£${(abs / 1_000_000).toFixed(abs >= 10_000_000 ? 0 : 1)}m`;
  if (abs >= 10_000) return `${sign}£${Math.round(abs / 1000)}k`;
  if (abs >= 1_000) return `${sign}£${(abs / 1000).toFixed(1)}k`;
  return `${sign}£${Math.round(abs)}`;
}

export function int(n: number | null | undefined): string {
  if (n === null || n === undefined || !isFinite(n)) return "—";
  return intFmt.format(n);
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${int(n)} ${n === 1 ? one : many}`;
}

export function initials(name: string | null | undefined): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "") + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "")).toUpperCase();
}
